import { getSearchModeForSearchModel, SearchMode, } from '#pplx/frontend/ask-models/types/search-modes.js';
const NAV_RESULTS_QUERY_MAX_LENGTH = 35;
const NAV_SEARCH_EXCLUDED_MODES = new Set([
    SearchMode.STUDY,
    SearchMode.ASI,
    SearchMode.RESEARCH,
]);
export const isNavSearchExcludedMode = (modelPreference) => {
    const searchMode = getSearchModeForSearchModel(modelPreference);
    return NAV_SEARCH_EXCLUDED_MODES.has(searchMode);
};
export const shouldRunNavigationalSearch = ({ query, isFollowup, attachmentsLength, sourcesLength, modelPreference, }) => {
    const isQueryShort = query.length <= NAV_RESULTS_QUERY_MAX_LENGTH;
    return (isQueryShort &&
        !isFollowup &&
        attachmentsLength === 0 &&
        sourcesLength > 0 &&
        !isNavSearchExcludedMode(modelPreference));
};
//# sourceMappingURL=shouldRunNavigationalSearch.js.map